'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 解析javascript
 */
function DOMEval(code) {
    var script = document.createElement('script');
    script.text = code;
    document.head.appendChild(script).parentNode.removeChild(script);
}

/**
 * post+jsonp
 */
function postJsonp(params) {
    return new Promise(function (resolve, reject) {
        var postJsonpParams = Object.assign({}, params);
        postJsonpParams.params = (0, _extends4.default)({}, params.params, (0, _defineProperty3.default)({}, params.jsonpCallback || 'callback', params.jsonpCallbackName || '__jp' + new Date().getTime()));

        delete postJsonpParams.type;
        delete postJsonpParams.jsonpCallback;
        delete postJsonpParams.jsonpCallbackName;

        var jsonpName = postJsonpParams.params[params.jsonpCallback || 'callback'];
        var postJsonpData = void 0;
        window[jsonpName] = function (data) {
            postJsonpData = data;
        };

        var axiosParams = (0, _utils.toAxiosParams)(postJsonpParams);

        (0, _axios2.default)(axiosParams).then(function (response) {
            DOMEval(response.data);
            return response;
        }).then(function (response) {
            response.data = postJsonpData;
            resolve(response);
        }).catch(function (err) {
            reject(err);
        });
    });
}

exports.default = postJsonp;